import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { Store } from '@/types/stores.types';
import { useSTKContext } from '@/context/context';

export const useStores = (enabled: boolean, groupId?: string) => {
  const { apiClient } = useSTKContext();
  return useQuery<AxiosResponse<Store[]>>({
    queryKey: ['stores', groupId],
    queryFn: () => apiClient.get<Store[]>(`/stores`, { params: { groupId } }),
    enabled,
  });
};

export const useGetAllStores = (enabled: boolean, groupId?: string) => {
  const { apiClient } = useSTKContext();
  return useQuery<Store[]>({
    queryKey: ['all-stores', groupId],
    queryFn: async () => {
      const allStores = await apiClient.get<Store[]>(`/stores`, { params: { groupId } });
      return allStores.data;
    },
    enabled,
  });
};

export const useStoreOnboarding = () => {
  const { apiClient } = useSTKContext();
  return useMutation({
    mutationFn: (storeOnboard: { newStore?: string; copyStore?: string }) =>
      apiClient
        .post(`store-onboard?newStore=${storeOnboard.newStore}&copyStore=${storeOnboard.copyStore}`)
        .then((response) => response.data),
  });
};
